import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "saddle-selection__results" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 0 }

import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { useSaddleStore } from '@/store/saddleStore'
import {
  ListItemState,
  BfLoader,
  BfList,
  BfListItem,
  BfFlex,
  BfInput,
} from '@finetic/bikefitting-ui'
import { useDebounceFn } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import SelectionDetails from '@/components/setup/SelectionDetails.vue'
import SelectionDetailsItem from '@/components/setup/SelectionDetailsItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SaddleSelection',
  emits: ['select'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const userStore = useUserStore()
const saddleStore = useSaddleStore()
const { sessionId } = storeToRefs(userStore)
const { saddleData, filters } = storeToRefs(saddleStore)
const loading = ref(false)
const selected = ref()

const shapeKeyMap: Record<string, string> = {
  FLAT: 'flat',
  'SEMI ROUND': 'semiCurved',
  ROUND: 'curved',
}

const emit = __emit

const select = (saddle: any) => {
  selected.value = saddle
  emit('select', saddle)
}

const search = () => {
  selected.value = undefined
  loading.value = true

  saddleStore.reset()
  saddleStore.retrieveSaddles(sessionId?.value ?? '').then(() => {
    loading.value = false
  })
}

const shapeLabel = computed(() => {
  const shape = selected.value?.SHAPE?.toUpperCase() ?? ''
  const key = shapeKeyMap[shape]
  return key ? t(`setup.saddle.shape.${key}`) : '-'
})

const shapeIcon = computed(() => {
  const shape = selected.value?.SHAPE?.toUpperCase() ?? ''

  switch (shape) {
    case 'FLAT':
      return '/icons/filters/saddle-shape__flat.svg'

    case 'SEMI ROUND':
      return '/icons/filters/saddle-shape__semi.svg'

    case 'ROUND':
      return '/icons/filters/saddle-shape__curved.svg'

    default:
      return '/icons/filters/saddle-shape__flat.svg'
  }
})

const anatomicalIcon = computed(() => {
  return selected.value?.ANATOMIC_DESIGN
    ? '/icons/filters/saddle-anatomical__yes.svg'
    : '/icons/filters/saddle-anatomical__no.svg'
})

const updateSearch = useDebounceFn(() => {
  search()
}, 300)

search()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BfFlex), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BfInput), {
          modelValue: _unref(filters).FreeTextSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).FreeTextSearch) = $event)),
          name: _unref(t)('common.search.filterBrandOrModel'),
          placeholder: _unref(t)('common.search.filterBrandOrModel'),
          style: {"flex":"1"},
          onKeyup: _unref(updateSearch)
        }, null, 8, ["modelValue", "name", "placeholder", "onKeyup"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(BfLoader), { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(saddleData).length > 0)
        ? (_openBlock(), _createBlock(_unref(BfList), { key: 1 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(saddleData), (saddle, i) => {
                return (_openBlock(), _createBlock(_unref(BfListItem), {
                  key: i,
                  text: `${saddle.SADDLE_BRAND} ${saddle.SADDLE_MODEL} (${saddle.SADDLE_WIDTH} ${_unref(t)('common.unit.mm')})`,
                  state: 
          saddle === selected.value ? _unref(ListItemState).Active : _unref(ListItemState).Enabled
        ,
                  onClick: ($event: any) => (select(saddle))
                }, null, 8, ["text", "state", "onClick"]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(t)('common.search.noResults')), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    (selected.value)
      ? (_openBlock(), _createBlock(SelectionDetails, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(SelectionDetailsItem, {
              label: _unref(t)('setup.saddle.width'),
              value: `${selected.value.SADDLE_WIDTH} ${_unref(t)('common.unit.mm')}`,
              icon: "/icons/filters/saddle__width.svg"
            }, null, 8, ["label", "value"]),
            _createVNode(SelectionDetailsItem, {
              label: _unref(t)('setup.saddle.shape.index'),
              value: shapeLabel.value,
              icon: shapeIcon.value
            }, null, 8, ["label", "value", "icon"]),
            _createVNode(SelectionDetailsItem, {
              label: _unref(t)('setup.saddle.anatomical'),
              value: selected.value.ANATOMIC_DESIGN ? _unref(t)('common.yes') : _unref(t)('common.no'),
              icon: anatomicalIcon.value
            }, null, 8, ["label", "value", "icon"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})